import { Link } from "@mui/material";

const LinkComponent = ({children, onClick}) => {
    return (
        <Link onClick={onClick} style={{ fontWeight: 'lighter'}}>{children}</Link>
    );
}

export default LinkComponent;